import { cinemaHref, storeCinemaSlug } from "./cinemaSlugs"

export const AFISHA_TABS = ["Афиша", "Скоро", "Подборки", "Акции", "Новости"] as const

export type AfishaTab = (typeof AFISHA_TABS)[number]

/* «Новости» временно скрыты — контента пока нет */
export const AFISHA_VISIBLE_TABS: readonly AfishaTab[] = AFISHA_TABS.filter(t => t !== "Новости")

/** URL-slug → вкладка афиши */
export const AFISHA_TAB_SLUGS: Record<string, AfishaTab> = {
    afisha: "Афиша",
    skoro: "Скоро",
    podborki: "Подборки",
    aktsii: "Акции",
    novosti: "Новости",
}

export const AFISHA_TAB_TO_SLUG = Object.fromEntries(
    Object.entries(AFISHA_TAB_SLUGS).map(([slug, tab]) => [tab, slug]),
) as Record<AfishaTab, string>

export function afishaTabFromSlug(slug: string | null): AfishaTab | null {
    if (!slug) return null
    return AFISHA_TAB_SLUGS[slug] ?? null
}

export function afishaHref(tab: AfishaTab = "Афиша", cinemaSlug?: string): string {
    const tabSlug = AFISHA_TAB_TO_SLUG[tab]
    const path = cinemaHref(cinemaSlug ?? storeCinemaSlug(), "/afisha")
    return tabSlug === "afisha" ? path : `${path}?tab=${tabSlug}`
}
